import { Cart } from '../../../../store';
import { serializeCartFromApi } from '../../../../store/helpers/serializers/cart';
import {
  eaptekaApi,
  responseHandler
} from '../../eaptekaApi';
import { ApiCart } from './types';

export const eaptekaApiRequestCartGet =
  eaptekaApi.createGetMethod('/cart', {
    mapResponse: async (response) =>
      responseHandler<Cart, ApiCart>(
        response,
        serializeCartFromApi
      )
  });
